<template>
  <div :class="`gh-radio-group radio-group-${name}`">
    <div class="radio-title">{{title}}</div>
    <div if="items" v-for="(item, index) in items" class="gh-radio" @click="selectRadio(`${name}-${index}`, item)">
      <v-icon v-if="item.pinned" class="approved">mdi-approval</v-icon>
      <template v-else>
        <input :id="`${name}-${index}`" type="radio" :name="name" :value="item.value" @change="toggleRadio(name)" class="hide" :checked="checked(item)"/>
        <v-icon :class="`icon ${name}-${index}`">{{icon(item)}}</v-icon>
      </template>
      <label>{{item.label}}</label>
    </div>
  </div>
</template>

<style lang="sass">
  .gh-radio-group
    margin-bottom: 20px

    .radio-title
      margin-bottom: 5px
      font-weight: 600

    .gh-radio
      cursor: pointer
      text-rendering: optimizelegibility
      margin-bottom: 5px

      .approved
        color: #0068b3

      .icon
        position: relative
        font-size: 18px
        top: -1px

      label
        margin-left: 4px
        cursor: pointer

      .mdi-checkbox-blank-circle
        color: #0068b3
</style>

<script>
export default {
  props: {
    title: String,
    name: String,
    items: Array,
    value: [String, Boolean, Number]
  },

  computed: {
  },

  methods: {
    checked (item) {
      if (this.value === null) return item.default
      return this.value === item.value
    },

    icon (item) {
      return this.checked(item) ? 'mdi-checkbox-blank-circle' : 'mdi-checkbox-blank-circle-outline'
    },

    toggleRadio (radioItem) {
      var icons = document.querySelectorAll(`.radio-group-${this.name} .icon`)
      for (var icon of icons) {
        if (icon.classList.contains(radioItem)) {
          icon.classList.add('mdi-checkbox-blank-circle')
          icon.classList.remove('mdi-checkbox-blank-circle-outline')
        } else {
          icon.classList.remove('mdi-checkbox-blank-circle')
          icon.classList.add('mdi-checkbox-blank-circle-outline')
        }
      }
    },

    selectRadio (radioItem, item) {
      if (item.pinned) return
      var radio = document.getElementById(radioItem)
      radio.checked = true
      this.toggleRadio(radioItem)
      this.$emit('radio-changed', item.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// gh-radio-group.vue?0bcf8c77